<h2 mat-dialog-title>{{ category.title }}</h2>
<mat-dialog-content class="no-padding">
  <section class="guidelines">
    <p>1 - {{ "brand.campaign.content.addContent.firstStep" | translate }}</p>
    <p>2 - {{ "brand.campaign.content.addContent.secondStep" | translate }}</p>
  </section>
  <section class="edition">
    <div class="content-type-selection">
      <h3>{{ "brand.campaign.content.addContent.type" | translate }}</h3>
      <div
        *ngFor="let contentType of CONTENT_TYPES"
        (click)="selectTab(contentType)"
        class="option"
        [ngClass]="{
          'option--disabled': !isTabActive(contentType),
          'option--active': isTabActive(contentType),
          'option--selected': isTabSelected(contentType)
        }"
      >
        <span>{{
          "brand.campaign.content.addContent." + (contentType | lowercase)
            | translate
        }}</span>
      </div>

      <ng-container *ngIf="contentType === CampaignContentType.Post">
        <h3>{{ "brand.campaign.content.addContent.subtype" | translate }}</h3>
        <div
          *ngFor="let postContentType of POST_CONTENT_TYPES"
          (click)="selectPostTab(postContentType)"
          class="option"
          [ngClass]="{
            'option--disabled': !isPostTabActive(postContentType),
            'option--active': isPostTabActive(postContentType),
            'option--selected': isPostTabSelected(postContentType)
          }"
        >
          <span>{{
            "brand.campaign.content.addContent." + (postContentType | lowercase)
              | translate
          }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="contentType === CampaignContentType.LinkedinPost">
        <h3>{{ "brand.campaign.content.addContent.subtype" | translate }}</h3>

        <div
          *ngFor="let postContentType of LINKEDIN_CONTENT_TYPES"
          (click)="linkedInPostContentType = postContentType"
          class="option option--active {{
            linkedInPostContentType === postContentType
              ? 'option--selected'
              : ''
          }}"
        >
          <span>{{
            "brand.campaign.content.addContent." + (postContentType | lowercase)
              | translate
          }}</span>
        </div>
      </ng-container>
    </div>
    <div class="example-container">
      <ng-container *ngIf="contentType === CampaignContentType.Post">
        <h3>
          {{ "brand.campaign.content.addContent.postExample" | translate }}
        </h3>
        <div class="image-container">
          <img alt="post example" [src]="getPostImageUrl(postMediaType)" />
        </div>
      </ng-container>
      <ng-container *ngIf="contentType === CampaignContentType.Banner">
        <h3>
          {{ "brand.campaign.content.addContent.bannerExample" | translate }}
        </h3>
        <div class="image-container">
          <img
            alt="post example"
            src="/assets/images/post-mockups/image-mockup_{{
              assetsLanguage()
            }}.png"
          />
        </div>
      </ng-container>
      <ng-container *ngIf="contentType === CampaignContentType.Video">
        <h3>
          {{ "brand.campaign.content.addContent.videoExample" | translate }}
        </h3>
        <div class="image-container">
          <img
            alt="post example"
            src="/assets/images/post-mockups/video-mockup_{{
              assetsLanguage()
            }}@2x.jpg"
          />
        </div>
      </ng-container>
      <ng-container *ngIf="contentType === CampaignContentType.GoogleAd">
        <h3>
          {{ "brand.campaign.content.addContent.googleAdExample" | translate }}
        </h3>
        <div class="image-container">
          <img
            alt="post example"
            src="/assets/images/post-mockups/google-ad-mockup_{{
              assetsLanguage()
            }}@2x.png"
          />
        </div>
      </ng-container>
      <ng-container *ngIf="contentType === CampaignContentType.LinkedinPost">
        <h3>
          {{ "brand.campaign.content.addContent.postExample" | translate }}
        </h3>
        <div class="image-container">
          <img
            alt="post example"
            [src]="getLinkedinPostImageUrl(linkedInPostContentType)"
          />
        </div>
      </ng-container>
    </div>
  </section>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn btn--transparent" tabindex="-1" [mat-dialog-close]="false">
    {{ "shared.cancel" | translate }}
  </button>
  <button class="btn btn--primary" tabindex="-1" (click)="onCreateContent()">
    <span>{{ "shared.create" | translate }}</span>
  </button>
</mat-dialog-actions>
